import {
  addMonths,
  subMonths,
  eachDayOfInterval,
  subDays,
  startOfMonth,
} from 'date-fns';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { SelectedDay, updateSelection } from './updateSelectionLogic';
import { formatName } from '~/common/utils/employeeUtils';
import { create } from 'zustand';
import _ from 'lodash';

type TimeTrackingStoreState = {
  currentDate: Date;
  nextMonth: () => void;
  prevMonth: () => void;
  selectedDays: SelectedDay[];
  lastSelectedDay: SelectedDay | null;
  lastSelectedColumn: Date | null;
  selectDay: (
    employee: Employee,
    day: Date,
    ctrlDown: boolean,
    shiftDown: boolean,
  ) => void;
  selectColumn: (
    selectedColumn: Date,
    ctrlDown: boolean,
    shiftDown: boolean,
  ) => void;
  employeeIdListOrderedByRowNr: number[];
  setOrderedEmployeeList: (employees: Employee[]) => void;
};

export const useTimetrackingStore = create<TimeTrackingStoreState>((set) => ({
  currentDate: startOfMonth(new Date()),
  nextMonth: () =>
    set((state) => ({ currentDate: addMonths(state.currentDate, 1) })),
  prevMonth: () =>
    set((state) => ({ currentDate: subMonths(state.currentDate, 1) })),
  selectedDays: [],
  lastSelectedDay: null,
  lastSelectedColumn: null,
  employeeIdListOrderedByRowNr: [],
  setOrderedEmployeeList: (employees: Employee[]) =>
    set(() => ({
      employeeIdListOrderedByRowNr: _.orderBy(employees, (emp: Employee) =>
        formatName(emp),
      ).map((emp) => Number(emp.id)),
    })),
  selectDay: (employee, day, ctrlDown, shiftDown) =>
    set((state) => {
      const [newSelectedDays, newLastSelectedDay, newLastSelectedColumn] =
        updateSelection(
          state.employeeIdListOrderedByRowNr,
          state.selectedDays,
          state.lastSelectedDay,
          state.lastSelectedColumn,
          employee,
          day,
          ctrlDown,
          shiftDown,
        );

      return {
        selectedDays: newSelectedDays,
        lastSelectedDay: newLastSelectedDay,
        lastSelectedColumn: newLastSelectedColumn,
      };
    }),
  selectColumn: (day, ctrlDown, shiftDown) =>
    set((state) => {
      const [newSelectedDays, newLastSelectedDay, newLastSelectedColumn] =
        updateSelection(
          state.employeeIdListOrderedByRowNr,
          state.selectedDays,
          state.lastSelectedDay,
          state.lastSelectedColumn,
          null,
          day,
          ctrlDown,
          shiftDown,
        );

      return {
        selectedDays: newSelectedDays,
        lastSelectedDay: newLastSelectedDay,
        lastSelectedColumn: newLastSelectedColumn,
      };
    }),
}));

export const getDays = (currentDate: Date) => {
  return eachDayOfInterval({
    start: currentDate,
    end: subDays(addMonths(currentDate, 1), 1),
  });
};
